import Content from './content';
import { useTranslation } from '@CS/hooks';
import { type PopupProps, Popup } from '@CS/components/Popups';
import { DescriptionContainer, ErrorDescription } from './RequestError.styles';

type RequestErrorProps = PopupProps & {
  info?: {
    message?: string;
    error?: string;
    code?: number;
  };
};

export const RequestError = ({ info = {}, ...props }: RequestErrorProps) => {
  const { title, retry } = useTranslation(Content);
  const { code, error, message } = info;

  return (
    <Popup {...props} width="90" overlay>
      <DescriptionContainer>
        <h2>{(!code && error) || title}</h2>

        {(code || message) && (
          <ErrorDescription>
            {code && (
              <strong>
                {code && `${code}${error ? ': ' : ''}`}
                {error}
              </strong>
            )}

            <span>{message}</span>
          </ErrorDescription>
        )}

        <em>{retry}</em>
      </DescriptionContainer>
    </Popup>
  );
};
